export enum OENOperationMode {
  NEW,
  DUPLICATE,
  MODIFY,
  MODIFY_INFO,
  MONITOR_EXECUTION,
  AMEND_MARKUP,
  EDIT,
  MODIFY_SCRATCHPAD,
}
